
<div class="main-wrapper">
    <div
      class="main-content"
      [ngClass]="{
        'main-content_active': burgerMenu,
        'main-content_no-scroll': burgerMenuNoScroll
      }"
    >
      <!-- global markup for header -->
      <header
        class="header"
        [ngClass]="{'main-content_absolute': headerAbsolute}"
      >
        <div class="content">
          <div class="header__block row">
            <div class="header__arrow col image">
              <img src="../../../assets/images/header/back-arrow.svg" alt="arrow"  (click)="Back()">
            </div>
            <div class="header__title col">
               עריכת לקוח
            </div>
            <div
            class="header__burger col image"
          
            style="text-decoration: underline;"
          >
          <!-- <b>
            חזור
          </b> -->
            
          </div>

          </div>
        </div>
      </header>

      <form [formGroup]="form"  (ngSubmit)="AddClient()"> 
                <div style="width: 99%;margin: auto;margin-top: 100px;text-align: center;">
                    <table>
                        <tr>
          
                          <th>עריכה</th>
                          <th >שדה</th>
                        </tr>
                        <!------------->
                        <tr>
                        
                          <td style="padding: 0px;">
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;"  dir="rtl"  formControlName="CustName">
                          </td>
                          <td> שם לקוח</td>
                        </tr>
                        <!------------->
                        <tr>
                    
                          <td style="padding: 0px;">
                          
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;" dir="rtl"  formControlName="CustNum">
                    
                          </td>
                          <td> מספר לקוח</td>
                        </tr>
                         <!------------->
                        <tr>
               
                          <td style="padding: 0px;">
                          
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;"  dir="rtl"  formControlName="CustServer">
               
                          </td>
                          <td> שרת</td>
                        </tr>
                        <!------------->
                        <tr>
               
                          <td style="padding: 0px;">
                              
                            <input type="text" style="height: 45px;font-size: 35px;font-weight: 500;"  dir="rtl"  formControlName="CustImageDomain">
                          
                          </td>
                          <td> תמונות</td>
                        </tr>
                        
                    </table>
                    <button style="width: 120px;margin: auto; height: 45px;font-size: 35px;font-weight: 500px;margin-top: 30px;">אישור</button>
                        
                </div>
        </form>

     </div>
    </div>